(function () {
  function baseUrl(u) { return (u || '').split('?')[0]; }

  /* ---------- Galerie ---------- */
  function galleryOf(el) {
    var g = el.closest ? el.closest('[data-gallery]') : null;
    if (!g) return null;
    if (!g._api) {
      var main = g.querySelector('[data-gallery-main]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
      var idxEl = g.querySelector('[data-gallery-index]');
      if (!main) return null;
      g._api = {
        current: function () {
          var cur = baseUrl(main.getAttribute('src'));
          var i = thumbs.findIndex(function (t) { return baseUrl(t.getAttribute('data-src')) === cur; });
          return i < 0 ? 0 : i;
        },
        show: function (i) {
          if (!thumbs.length) return;
          i = (i + thumbs.length) % thumbs.length;
          main.src = thumbs[i].getAttribute('data-src');
          thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
          if (idxEl) idxEl.textContent = i + 1;
        },
        showUrl: function (url) {
          var target = baseUrl(url);
          var i = thumbs.findIndex(function (t) { return baseUrl(t.getAttribute('data-src')) === target; });
          if (i >= 0) { g._api.show(i); }
          else { main.src = url; thumbs.forEach(function (t) { t.classList.remove('on'); }); }
        },
        main: main
      };
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) g._api.show(g._api.current() + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    return g._api;
  }

  /* ---------- Kaufformular: Zustand pro Formular, lazy ---------- */
  function stateOf(form) {
    if (form._state) return form._state;
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return null;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var s = {
      variants: product.variants || [],
      optionNames: (product.options || []).map(function (o) { return (typeof o === 'string') ? o : o.name; }),
      selected: {},
      T: {
        add: form.getAttribute('data-t-add') || 'Add to cart',
        soldout: form.getAttribute('data-t-soldout') || 'Sold out',
        select: form.getAttribute('data-t-select') || 'Please choose options'
      }
    };
    form.querySelectorAll('[data-opt].on').forEach(function (el) { s.selected[el.getAttribute('data-opt')] = el.getAttribute('data-value'); });
    form._state = s;
    refresh(form);
    return s;
  }

  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  function refresh(form, changedName) {
    var s = form._state; if (!s) return;
    var names = s.optionNames, sel = s.selected, variants = s.variants;
    function availableFor(name, value) {
      var idx = names.indexOf(name);
      return variants.some(function (v) {
        if (v.options[idx] !== value) return false;
        return v.available && names.every(function (n, i) { if (n === name) return true; return sel[n] === undefined || v.options[i] === sel[n]; });
      });
    }
    form.querySelectorAll('[data-opt]').forEach(function (el) {
      if (!el.classList.contains('size')) return;
      el.classList.toggle('size--out', !availableFor(el.getAttribute('data-opt'), el.getAttribute('data-value')));
    });
    var all = names.every(function (n) { return sel[n] !== undefined; });
    var v = all ? variants.find(function (x) { return names.every(function (n, i) { return x.options[i] === sel[n]; }); }) : null;
    var idInput = form.querySelector('[data-variant-id]'), priceEl = form.querySelector('[data-price]'),
        wasEl = form.querySelector('[data-was]'), addBtn = form.querySelector('[data-add]');
    if (v) {
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) { if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price); wasEl.style.display = ''; } else { wasEl.style.display = 'none'; } }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? s.T.add : s.T.soldout; }
    } else if (addBtn) { addBtn.disabled = true; addBtn.textContent = s.T.select; }

    if (changedName !== undefined) {
      var img = variants.find(function (x) {
        return x.image && names.every(function (n, i) { return sel[n] === undefined || x.options[i] === sel[n]; });
      });
      var api = galleryOf(form);
      if (img && img.image && api) api.showUrl(img.image);
    }
  }

  function selectOption(el) {
    var form = el.closest('[data-buy]'); if (!form) return;
    var s = stateOf(form); if (!s) return;
    if (el.classList.contains('size--out')) return;
    var name = el.getAttribute('data-opt'), value = el.getAttribute('data-value');
    s.selected[name] = value;
    form.querySelectorAll('[data-opt][data-optname="' + name + '"]').forEach(function (x) { x.classList.remove('on'); });
    el.classList.add('on');
    var label = form.querySelector('[data-color-label]');
    if (label && el.classList.contains('swatch')) label.textContent = value;
    refresh(form, name);
  }

  /* ---------- Ein zentraler Klick-Handler für alles ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var opt = t.closest('[data-opt]');
    if (opt) { e.preventDefault(); selectOption(opt); return; }
    var thumb = t.closest('[data-gallery-thumb]');
    if (thumb) { var api = galleryOf(thumb); if (api) api.showUrl(thumb.getAttribute('data-src')); return; }
    var prev = t.closest('[data-gallery-prev]');
    if (prev) { var a1 = galleryOf(prev); if (a1) a1.show(a1.current() - 1); return; }
    var next = t.closest('[data-gallery-next]');
    if (next) { var a2 = galleryOf(next); if (a2) a2.show(a2.current() + 1); return; }
    var burger = t.closest('[data-burger]');
    if (burger) { var nav = document.getElementById(burger.getAttribute('aria-controls')); if (nav) nav.classList.toggle('open'); }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.target && /input|textarea|select/i.test(e.target.tagName)) return;
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('[data-opt]')) { e.preventDefault(); selectOption(e.target.closest('[data-opt]')); return; }
    var g = document.querySelector('[data-gallery]'); if (!g) return;
    var api = galleryOf(g); if (!api) return;
    if (e.key === 'ArrowLeft') api.show(api.current() - 1);
    if (e.key === 'ArrowRight') api.show(api.current() + 1);
  });

  /* Anfangszustand (Button-Text, Verfügbarkeit) – sofort und nach Editor-Neuaufbau */
  function initAll() { document.querySelectorAll('[data-buy]').forEach(function (f) { f._state = null; stateOf(f); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
